import React from 'react';

const OurClients = () => {
  return (
    <section className="py-32 relative overflow-hidden" style={{ backgroundColor: '#0a0f1c' }}>
      {/* Organic gradient on the right with animations */}
      <div className="absolute -top-20 -right-20 w-[800px] h-[800px]">
        <div
          className="absolute top-20 right-0 w-[600px] h-[600px] bg-gradient-to-br from-purple-500/30 via-indigo-500/25 to-blue-500/20 rounded-full blur-3xl"
          style={{
            animation: 'floatSlow 10s ease-in-out infinite'
          }}
        ></div>
        <div
          className="absolute top-60 right-40 w-[500px] h-[500px] bg-gradient-to-tl from-indigo-400/25 via-purple-400/20 to-violet-400/15 rounded-full blur-2xl"
          style={{
            animation: 'driftRight 12s ease-in-out infinite'
          }}
        ></div>
      </div>

      {/* Organic gradient on the bottom left with animations */}
      <div className="absolute -bottom-40 -left-40 w-[900px] h-[900px]">
        <div
          className="absolute bottom-0 left-0 w-[700px] h-[700px] bg-gradient-to-br from-indigo-500/35 via-purple-500/25 to-violet-500/20 rounded-full blur-3xl"
          style={{
            animation: 'floatLeft 14s ease-in-out infinite'
          }}
        ></div>
        <div
          className="absolute bottom-40 left-40 w-[600px] h-[600px] bg-gradient-to-tl from-purple-400/30 via-indigo-400/20 to-blue-400/15 rounded-full blur-2xl"
          style={{
            animation: 'driftLeft 8s ease-in-out infinite'
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="mb-20 text-center">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 text-sm font-semibold tracking-widest uppercase text-purple-300 rounded-full backdrop-blur-sm">
              OUR CLIENTS
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-AfacadFluxLight font-light text-white leading-tight max-w-5xl mx-auto mb-8">
            Trusted by{' '}
            <span className="bg-gradient-to-r from-purple-400 via-indigo-400 to-blue-400 bg-clip-text text-transparent">
              Thousands
            </span>
          </h2>
        </div>

        {/* Main Content */}
        <div className="max-w-6xl mx-auto space-y-16">
          {/* Description Section */}
          <div className="text-center space-y-8">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-light font-AfacadFluxLight max-w-5xl mx-auto">
              We have assisted over thousands of clients in the 25 year old history of the Company including centralization of financial institutions, critically compliant US healthcare industry, Luxury tourism industry, Robotics and Process Automation industry, IT/ITES industry and many more Government backed and Private Small and Medium Enterprises, while assisting over 30+ new clients on a monthly basis.
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-light font-AfacadFluxLight max-w-5xl mx-auto">
              Most of our clients are Multi-Million Dollar valued organizations from USA, UK, Australia, Singapore, UAE and many more regions, with continued patronage even beyond the Start-up stage.
            </p>

            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-light font-AfacadFluxLight max-w-5xl mx-auto">
              We are here to ignite the fire, but we add continuous value for any Company to consistently meet Goal after Goal. We are here for a Lifetime because it is worth the presence.
            </p>
          </div>

          {/* Stats Section */}
          <div className="pt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
              <div className="text-center group">
                <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="text-3xl md:text-4xl font-bold text-white font-AfacadFluxLight mb-2">
                  25+
                </div>
                <div className="text-gray-400 font-AfacadFluxLight">
                  Years of Experience
                </div>
              </div>

              <div className="text-center group">
                <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div className="text-3xl md:text-4xl font-bold text-white font-AfacadFluxLight mb-2">
                  30+
                </div>
                <div className="text-gray-400 font-AfacadFluxLight">
                  New Clients Monthly
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes floatSlow {
          0%, 100% {
            transform: translate(0px, 0px) rotate(0deg);
          }
          33% {
            transform: translate(30px, -30px) rotate(2deg);
          }
          66% {
            transform: translate(-20px, 20px) rotate(-1deg);
          }
        }

        @keyframes driftRight {
          0%, 100% {
            transform: translate(0px, 0px) scale(1);
          }
          50% {
            transform: translate(40px, -20px) scale(1.1);
          }
        }

        @keyframes floatLeft {
          0%, 100% {
            transform: translate(0px, 0px) rotate(0deg);
          }
          33% {
            transform: translate(-30px, 30px) rotate(-2deg);
          }
          66% {
            transform: translate(20px, -20px) rotate(1deg);
          }
        }

        @keyframes driftLeft {
          0%, 100% {
            transform: translate(0px, 0px) scale(1);
          }
          50% {
            transform: translate(-40px, 20px) scale(1.1);
          }
        }
      `}</style>
    </section>
  );
};

export default OurClients; 